"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonColor = exports.ButtonSize = exports.ButtonVariant = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["Primary"] = "Primary";
    ButtonVariant["PrimaryContrast"] = "PrimaryContrast";
    ButtonVariant["Secondary"] = "Secondary";
    ButtonVariant["SecondaryLight"] = "SecondaryLight";
    ButtonVariant["SecondaryLightContrast"] = "SecondaryLightContrast";
    ButtonVariant["SmallBordered"] = "SmallBordered";
    ButtonVariant["Text"] = "Text";
    ButtonVariant["Link"] = "Link";
    ButtonVariant["TextTopbar"] = "TextTopbar";
    ButtonVariant["Bordered"] = "Bordered";
})(ButtonVariant || (exports.ButtonVariant = ButtonVariant = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Large"] = "Large";
    ButtonSize["Medium"] = "Medium";
    ButtonSize["Small"] = "Small";
})(ButtonSize || (exports.ButtonSize = ButtonSize = {}));
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["Primary"] = "Primary";
    ButtonColor["Default"] = "Default";
    ButtonColor["Green"] = "Green";
    ButtonColor["Red"] = "Red";
    ButtonColor["Orange"] = "Orange";
    ButtonColor["Blue"] = "Blue";
    ButtonColor["Violet"] = "Violet";
    ButtonColor["Pink"] = "Pink";
    ButtonColor["White"] = "White";
    ButtonColor["Grey"] = "Grey";
    ButtonColor["Inherit"] = "Inherit";
})(ButtonColor || (exports.ButtonColor = ButtonColor = {}));
exports.Button = react_1.default.forwardRef(({ children, variant = ButtonVariant.PrimaryContrast, size = ButtonSize.Medium, color = ButtonColor.Primary, iconStart, iconEnd, tagName: TagName = 'button', type = 'button', fullWidth, noWrap, ...props }, ref) => ((0, jsx_runtime_1.jsxs)(TagName, { ref: ref, type: type, className: (0, classnames_1.default)(styles_module_css_1.default.button, styles_module_css_1.default[`button${size}Size`], styles_module_css_1.default[`button${color}Color`], styles_module_css_1.default[`button${variant}Variant`], { [styles_module_css_1.default.buttonFullWidth]: fullWidth }, { [styles_module_css_1.default.buttonNoWrap]: noWrap }), ...props, children: [iconStart && ((0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(styles_module_css_1.default.buttonIcon, styles_module_css_1.default.buttonIconLeft, {
                buttonIconLeftBig: iconStart.type.size === 16,
            }), children: iconStart })), (0, jsx_runtime_1.jsx)("span", { children: children }), iconEnd && ((0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)(styles_module_css_1.default.buttonIcon, styles_module_css_1.default.buttonIconRight), children: iconEnd }))] })));
exports.default = exports.Button;
